import { Button } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyleModalLogsTotem = createGlobalStyle`
    &.ant-modal-body {
        padding: 0px !important;
    }
    &.ant-divider-horizontal {
        margin: 0 !important;
        margin-bottom: 24px !important;
    }
    &.ant-select-selection-item {
        justify-content: center !important;
    }
`;

export const ButtonGoBack = styled(Button).attrs({
    children: 'Voltar',
})``;

export const ButtonExport = styled(Button).attrs({
    type: 'primary',
    children: 'Exportar',
})``;

export const CustomFooterContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    padding: 10px 0;
`;
